import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Tune from "../../assets/TuneUps.png";

const TuneUpService = () => {
  return (
    <>
      <SeoHead
        title="Engine Tune-Up Service in Temecula | Advanced Automotive Smog"
        description="Tune-up service in Temecula covering spark plugs, filters, and a multi-point inspection to help your engine run smoother and more efficiently."
        path="/services/tune-ups"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Tune Up Service"
          path="/services/tune-ups"
          description="Tune-up service in Temecula covering spark plugs, filters, and a multi-point inspection."
          serviceType="Engine tune-up"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Tune}
                alt="Engine tune up service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Performance Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-navy-900 mb-3">
              Tune Up Service
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Keep your engine running at peak performance. Our tune-up service
              restores power, improves efficiency, and helps your vehicle start
              easier and run smoother every day.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Tune Up?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              A tune-up is a targeted maintenance service that refreshes key
              components of your ignition and fuel systems. We inspect and
              replace worn parts like spark plugs and filters, and check for any
              issues that could hold your engine back.
              <br />
              <br />
              Our technicians also perform a multi-point inspection to spot
              small problems before they turn into expensive repairs.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Thorough engine diagnostics and performance check
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Spark plug, air filter &amp; fuel filter replacement as needed
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps improve fuel efficiency and throttle response
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Reduces misfires, rough idle, and hard starts
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Preventive maintenance to avoid costly future repairs
              </li>
            </ul>

            {/* Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default TuneUpService;

